import { trigger_interaction } from './Analytics';
import * as ENV from "../env";


export function selectTitleHeader() {
    trigger_interaction('GLOBAL', 'o', 'TITLE');
}
export function selectHelp() {
    trigger_interaction('GLOBAL', 'o', 'HELP');
}
export function selectScrollToTop() {
    trigger_interaction('GLOBAL', 'o', 'HOME, SCROLL');
}
